import { ContractTypesEnum } from '@/common/constants/contract.types.constants';
import { PartiesEnum } from '@/common/constants/parties.constants';
import { getValidationMessages } from '@/common/constants/validation-messages';
import * as yup from 'yup';

const messages = getValidationMessages();

export const contractSchema = yup.object().shape({
  crop_generation_type: yup.string().when('$dealType', {
    is: ContractTypesEnum.STORAGE,
    then: () => yup.string().required(messages.required),
    otherwise: () => yup.string().optional(),
  }),
  farmer_contract_id: yup.string().required(messages.required),
  crop_generation_id: yup.string().when('crop_generation_type', {
    is: PartiesEnum.SEED,
    then: (schema) => schema.required(messages.required),
    otherwise: (schema) => schema.notRequired(),
  }),
  storage_type: yup.string().when('crop_generation_type', {
    is: PartiesEnum.SEED,
    then: (schema) => schema.required(messages.required),
    otherwise: (schema) => schema.notRequired(),
  }),
});
